var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUniformlyDistributedLoadW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 123,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2710 -1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2738.5 1526.5 2847.43 1526.5",
    stroke: "#FFFFFF",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2849.22 1526.5 2849.22 1595.98 2845.78 1595.98 2845.78 1526.5ZM2861.25 1591.4 2847.5 1618.9 2833.75 1591.4Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2740.22 1526.5 2740.22 1595.98 2736.78 1595.98 2736.78 1526.5ZM2752.25 1591.4 2738.5 1618.9 2724.75 1591.4Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2776.22 1526.5 2776.22 1595.98 2772.78 1595.98 2772.78 1526.5ZM2788.25 1591.4 2774.5 1618.9 2760.75 1591.4Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2813.22 1526.5 2813.22 1595.98 2809.78 1595.98 2809.78 1526.5ZM2825.25 1591.4 2811.5 1618.9 2797.75 1591.4Z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniformlyDistributedLoadW);
export default __webpack_public_path__ + "static/media/uniformly_distributed_load-w.6712e1fd0bb434797638dade74c8e773.svg";
export { ForwardRef as ReactComponent };